import { render } from "./Packing3dButtons.vue?vue&type=template&id=34de99a7"
import script from "./Packing3dButtons.vue?vue&type=script&lang=js"
export * from "./Packing3dButtons.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__